export default function EvaluareNationalaPage() {

  const documente = [
    { titlu: "Model cerere contestații - word", fisier:"/educatie/evaluareNationala2026/Model_cerere_contestatii.docx", download: true},
    { titlu: "Model cerere contestații - pdf", fisier:"/educatie/evaluareNationala2026/Model_cerere_contestatii.pdf"},
    { titlu: "Procedură vizualizări lucrări", fisier:"/educatie/evaluareNationala2026/2026-05-13-27324-mec-proc-vizualizare-lucrari-scrise.pdf"},
    { titlu: "Cerere vizualizare", fisier:"/educatie/evaluareNationala2026/22-EN08-CEX-Cerere-Vizualizare-Lucrare-(Avizier CEX).pdf"},
    { titlu: "Declarație confirmare vizualizare lucrare", fisier:"/educatie/evaluareNationala2026/23-EN08-CEX-Declaratie-Confirmare-Vizualizare-(Avizier CEX).pdf"},
    { titlu: "Calendar", fisier:"/educatie/evaluareNationala2026/CALENDAR.pdf"},
    { titlu: "În atenția candidaților", fisier:"/educatie/evaluareNationala2026/În atenția elevilor.pdf"},
    { titlu: "Accesul persoanelor", fisier:"/educatie/evaluareNationala2026/12-EN08-CEX-Accesul-persoanelor-(Avizier CEX + Usa sala).pdf"},
    { titlu: "Tel. verde", fisier:"/educatie/evaluareNationala2026/18-EN08-CEX-2026-06-09-5998-Anunt-anticoruptie-tel-verde.pdf"},
    { titlu: "METODOLOGIA DE ORGANIZARE SI DESFASURARE A EVALUARII NATIONALE", fisier: "/educatie/evaluareNationala2026/2010-08-31-4801-omects-met-org-&-desf-en08.pdf"},
    { titlu: "ORDIN privind organizarea şi desfăşurarea evaluării naţionale", fisier: "/educatie/evaluareNationala2026/2025-08-29-6058-omec-met-org-&-desf-en08-2025-2026.pdf"},
    { titlu: "PROCEDURĂ cu privire la asigurarea condițiilor de egalizare a șanselore", fisier: "/educatie/evaluareNationala2026/2025-10-27-32051-mec-proc-asig-cond-egalizare-sanse-en08-&-bac.pdf" },
    { titlu: "Comunicare rezultat", fisier: "/educatie/evaluareNationala2026/2026-05-13-27325-mec-proc-comunicare-rezultate.pdf"},
];

  return (
    <div className="bg-gray-50 min-h-screen">
      <main className="max-w-7xl mx-auto px-4 py-8">

        <div className="mb-12">
          <h2 className="text-3xl font-bold mb-6">
            Evaluare Națională
          </h2>

          <div className="flex justify-center mb-4">
            <iframe
              src="/educatie/evaluareNationala2026/ANUNT candidati.pdf"
              title="Anunt EN"
              className="w-full h-[90vh] border rounded"
            ></iframe>
          </div>

          <ul className="space-y-3">
            {documente.map((doc, index) => (
              <li key={index}>
                <a
                href={doc.fisier}
                target={doc.download ? "_self" : "_blank"}
                rel="noopener noreferrer"
                download={doc.download ? true : undefined}
                className="text-blue-600 hover:underline"
                >
                {doc.titlu}
                </a>
              </li>
            ))}
          </ul>

        </div>

      </main>
    </div>
  );
}